<template lang="pug">
  .container.grid-xl
    page-title(title="Balanço do afiliado" icon="fas fa-hand-holding-usd" subtitle="Detalhamento dos ganhos do afiliado")
      div(slot="actions")
        form-group(label="Pesquisar por mês")
          datepicker(v-model="month" input-class="form-input input-sm" type="month" format="MMMM [de] YYYY" @input="fetchBalance" :disabled-date="date => date > new Date()")
    .flex-centered.content-full-height(v-if="loading") #[.loading.loading-lg]
    .columns(v-else-if="balance")
      .column.col-12.my-2(v-if="balance.status === 'opened'")
        .toast.toast-warning
          span Este relatório foi atualizado em
          b  {{ balance.updatedAt | toDate('DD/MM/YYYY [as] HH:mm') }}
          span  alterações feitas após esta data ainda não foram caluladas
      .column.col-4.col-md-6.col-sm-12.my-2
        card-person(:person="balance.filiation.person")
      .column.col-5.col-md-6.col-xl-6.col-sm-12.my-2
        card-info(title="Filiação" icon="fas fa-handshake")
          .card-body(slot="card-body")
            .text-ellipsis #[span Código: #[span.text-bold {{ balance.filiation.code }}]]
            .text-ellipsis #[span Afiliado em: #[span.text-bold {{ balance.filiation.createdAt | toDate }}]]
            .text-ellipsis #[span Situaçao: #[span.text-bold(:class="balance.filiation.active ? 'text-success' : 'text-error'") {{ balance.filiation.active ? 'Ativo' : 'Inativo' }}]]
      .column.col-12.my-2.divider
      .column.col-12.my-2
        cite
          | Mês de referência:
          b  {{ referenceMonth }}
      .column.col-4.col-md-6.col-sm-12.my-2
        card-info(title="Status" icon="fas fa-spell-check")
          .card-body(slot="card-body")
            .flex-centered
              .h2.text-bold.ml-1(:class="balanceStatus[balance.status].textClass") {{ balance.status | balanceStatus }}
          .card-footer.text-center(slot="card-footer")
            cite.text-small {{ balanceStatus[balance.status].description }}
      .column.col-4.col-md-6.col-sm-12.my-2
        card-info(title="Total" icon="fas fa-money-bill-alt")
          .card-body(slot="card-body")
            .flex-centered
              .h2.text-bold.ml-1.text-success {{ balance.amount | currency('R$ ') }}
          .card-footer.text-center(slot="card-footer")
            cite.text-small
              | Este é o valor estimado dos ganhos do afiliado em 
              b  {{ referenceMonth }}
      .column.col-4.col-md-6.col-sm-12.my-2
        card-info(title="Ganhos" icon="fas fa-search-dollar")
          .card-body(slot="card-body")
            .centered
              .columns(v-for="monetization in balance.monetizations" :key="monetization.id")
                .column {{ monetization.type | monetizationType }}:
                .column.col-auto
                  b  {{ monetization.amount | currency('R$ ') }}
          .card-footer.text-center(slot="card-footer")
            cite.text-small Valor ganho em cada categoria de monetização
      .column.col-12.divider.my-2
      .column.col-12.my-2
        card-info(title="Detalhamento do balanço" icon="fas fa-clipboard-list")
          .card-body(slot="card-body")
            tabs
            router-view.details(:balance="balance")
      options(:balance="balance" @upgrade-balance="onUpgradeBalance")
    .flex-centered.content-full-height(v-else-if="error") #[error-box(:error="error")]
</template>

<script>
import moment from 'moment'
import filiations from '@/services/filiations'
import { BALANCE_STATUS } from '@/config/constants'
import Tabs from './components/Tabs'
import Options from './components/Options'

export default {
  components: { Options, Tabs },
  data() {
    return {
      balance: null,
      loading: true,
      error: null,
      month: null,
    }
  },
  computed: {
    referenceMonth() {
      return moment(this.balance.month)
        .utc()
        .format('MMMM [de] YYYY')
    },
    balanceStatus() {
      return BALANCE_STATUS
    },
  },
  methods: {
    async confirm(message, options = {}) {
      const config = {
        okLabel: 'Confirmar',
        cancelLabel: 'Cancelar',
        ...options,
      }
      return this.$dialogs.confirm(message, config)
    },

    async fetchBalance(forceUpgrade = null) {
      try {
        this.error = null
        this.loading = true
        const params = { q: { month: this.month, forceUpgrade } }
        const { data } = await filiations.balance(this.$route.params.id, params)
        this.balance = data
      } catch (e) {
        this.error = e
      } finally {
        this.loading = false
      }
    },

    async onUpgradeBalance() {
      const { ok } = await this.confirm(
        'Este processo pode levar alguns minutos',
        {
          title: 'Deseja atualizar o balanço?',
        },
      )

      if (ok) this.fetchBalance(true)
    },
  },
  created() {
    this.month = moment()
      .startOf('month')
      .toDate()
    this.fetchBalance()
  },
}
</script>

<style lang="stylus">
.details .content-full-height
  height auto
  padding 2rem 0
</style>

<style lang="stylus" scoped>
.centered
  display flex
  flex-direction column
  height 100%
  justify-content center

.content-full-height
  height calc(100vh - 55px - 75px - 48px - 26px)
</style>
